import React, { useContext, useEffect, useState } from "react";
import {Input} from "reactstrap";
import {RootStoreContext} from "../../core/store/rootStore";

const UserSelect = (props) => {
    const rootStore = useContext(RootStoreContext);
    const { loadUsers, userList } = rootStore.userStore;

    let [loading, setLoading] = useState(false);

    useEffect(() => {
        wrapLoadUsers();
    }, [loadUsers]);

    function wrapLoadUsers() {
        setLoading(true);
        loadUsers().then(() => {
            setLoading(false);
        });
    }

    function onFieldChange(event) {
        props.onChange(event);
    }

    return ( <Input className="mb-3" type="select" disabled={loading} onChange={onFieldChange.bind(this)} name={props.name} data-number={true}>
                <option value={null}>
                    Sélectionnez...
                </option>
                {userList.map((element, index) => (
                    <option key={index} value={element.id}>{element.name} {element.surname}</option>
                ))}
            </Input>)
};

export default UserSelect;